import { IPagination, IPaginationDTO } from '@/models/pagination.model';

export enum CommissionEndpoints {
  CATEGORY_COMMISSIONS = '/category-commissions',
  CATEGORY_COMMISSIONS_HISTORY = '/category-commissions/history',
  CATEGORY_COMMISSIONS_HISTORY_FILTERS = '/category-commissions/history/filters',
}

export interface ICategoryCommission {
  id: string;
  name: string;
  commission_percent: number;
  parent_id?: string | null;
  children?: ICategoryCommission[];
}

export interface ICategoryCommissionHistory {
  id: string;
  old_percent: number;
  new_percent: number;
  changed_at: string;
  category?: {
    id: string;
    name: string;
  };
  changed_by?: {
    id: string;
    full_name: string;
  };
}

export interface ICommissionHistoryFilterCategory {
  id: string;
  name: string;
}

export interface ICommissionHistoryFilterAdmin {
  id: string;
  full_name: string;
}

export interface ICommissionHistoryFilters {
  categories: ICommissionHistoryFilterCategory[];
  admins: ICommissionHistoryFilterAdmin[];
}

export interface IGetCategoryCommissionsResponse {
  data: ICategoryCommission[];
}

export interface IGetCategoryCommissionHistoryResponse {
  data: ICategoryCommissionHistory[];
}

export interface IGetCommissionHistoryListResponse {
  data: ICategoryCommissionHistory[];
  meta: IPagination;
}

export interface IGetCommissionHistoryFiltersResponse {
  data: ICommissionHistoryFilters;
}

export interface IUpdateCategoryCommissionItem {
  id: string;
  commission_percent: number;
}

export interface IUpdateCategoryCommissionsDTO {
  items: IUpdateCategoryCommissionItem[];
}

export interface IGetCategoryCommissionHistoryDTO {
  categoryId: string;
}

export interface IGetCommissionHistoryListDTO extends IPaginationDTO {
  date_from?: string;
  date_to?: string;
  category_id?: string;
  changed_by_admin_id?: string;
  limit?: number;
}
